import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

export function addNewsPostImage(file) {
  const storage = firebase.storage().ref();
  if (file && file.name) {
    const fileRef = storage.child(`news_posts/${Date.now()}-${file.name}`);
    return fileRef
      .put(file)
      .then(() => fileRef.getDownloadURL())
      .catch((err) => {
        console.log(err);
        throw err;
      });
  }

  return Promise.reject(new Error('Missing image file'));
}
